/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Action_ContentInputs */

const en_home_action_content = /** @type {(inputs: Home_Action_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recent breakthroughs on AI have started a race to the bottom. Too few people are well-informed about the potential risks of AI, so you can make the difference.`)
};

/**
* | output |
* | --- |
* | "Recent breakthroughs on AI have started a race to the bottom. Too few people are well-informed about the potential risks of AI, so you can make the difference." |
*
* @param {Home_Action_ContentInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_action_content = /** @type {((inputs?: Home_Action_ContentInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Action_ContentInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_action_content(inputs)
});